import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import MainContent from "./pages/demo/MainContent/MainContent";
import Sidebar from "./pages/demo/Sidebar/Sidebar";
import LoginPage from './pages/demo/LogInPage/LogIn';
import WelcomePage from './pages/demo/SignUpPage/WelcomePage';
import SignUP from './pages/demo/SignUpPage/SignUp';
import VerificationPage from './pages/demo/SignUpPage/Verification';
import PersonalDetails from './pages/demo/SignUpPage/PersonalDetails';
import SettingsPage from './pages/demo/SettingsPage/SettingsPage1';

import { AuthProvider } from './AuthContext';
import PrivateRoute from './PrivateRoute';
import AccountSettingsPage from './pages/demo/SettingsPage/SettingsPgae';
import { UnsavedChangesProvider, useUnsavedChanges } from "./context/UnsavedChangesContext";
import { MainContentProvider } from "./context/MainContentContext";
import ProtectedRoute from './components/ProtectedRoute';


function App() {
  // Move the modal logic inside the UnsavedChangesProvider
  return (
    <Router>
      <AuthProvider>
        <UnsavedChangesProvider>
        <MainContentProvider>
          <AppContent />
          </MainContentProvider>
        </UnsavedChangesProvider>
      </AuthProvider>
    </Router>
  );
}

function AppContent() {
  const { showNavigationModal, confirmNavigation, cancelNavigation } = useUnsavedChanges();

  const styles = {
    overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.4)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000,
    },
    modal: {
      background: '#ffffff',
      padding: '30px',
      borderRadius: '16px',
      textAlign: 'center',
      width: '340px',
      boxShadow: '0 10px 30px rgba(0, 0, 0, 0.2)',
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
      animation: 'fadeIn 0.3s ease-in-out',
    },
    title: {
      fontSize: '20px',
      fontWeight: '600',
      marginBottom: '10px',
      color: '#333',
    },
    message: {
      fontSize: '16px',
      fontWeight: '400',
      marginBottom: '20px',
      color: '#555',
    },
    button: {
      padding: '10px 24px',
      backgroundColor: '#007b8f',
      color: '#fff',
      border: 'none',
      borderRadius: '8px',
      fontSize: '15px',
      fontWeight: '500',
      cursor: 'pointer',
      transition: 'background-color 0.2s ease-in-out',
    },
  };

  return (
    <div className="App">
      {showNavigationModal && (
        <div style={styles.overlay}>
          <div style={styles.modal}>
            <h2 style={styles.title}>Unsaved Changes</h2>
            <p style={styles.message}>
              You have unsaved changes. Do you want to leave this page without saving?
            </p>
            <div style={{ display: "flex", justifyContent: "space-between", marginTop: "20px" }}>
              <button style={styles.button} onClick={confirmNavigation}>
                Yes, Leave
              </button>
              <button
                style={{ ...styles.button, backgroundColor: "#e53935" }}
                onClick={cancelNavigation}
              >
                No, Stay
              </button>
            </div>
          </div>
        </div>
      )}
      <Routes>
        {/* Public Routes */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/" element={<LoginPage />} />
        <Route path="/welcome" element={<WelcomePage />} />
        <Route path="/signup" element={<SignUP />} />
        <Route path="/verification" element={<VerificationPage />} />
        <Route path="/pd" element={<PersonalDetails />} />

        {/* Protected Routes */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <PrivateRoute>
                <div className="main-wrapper">
                  <div className="sidebar-main">
                    <Sidebar />
                  </div>
                  <div className="main-content">
                    <MainContent />
                  </div>
                </div>
              </PrivateRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/settings"
          element={
            <PrivateRoute>
              <div className="main-wrapper">
                <div className="sidebar-main">
                  <Sidebar />
                </div>
                <div className="main-content">
                  <AccountSettingsPage />
                </div>
              </div>
            </PrivateRoute>
          }
        />
      </Routes>
    </div>
  );
}

export default App;